export const makeLinkFromSquireName = (name, base_url) => {
  return base_url + "?n=" + name.replace(/ /g, "-");
};

export const sanitizeSquireName = (name) => {
  return name.replace(/ /g, "-");
};
